<template>
  <section>
    <gs-header title="Báo cáo">
    </gs-header>
    <div class="padding-sm-all">
      <gs-table
        v-if="showData"
        :ref="invoiceReportTable"
        :table-name="invoiceReportTable"
        data-source="invoices/report-by-crosscheck"
        :data-params="filters"
        :cache-data="false"
        :data-sorts="sorts"
        :data-sorted="sorted"
        @remove-filter="removeFilter"
      >
        <!-- :data-sorted="sorted"
        :data-sorts="sorts" -->
        <section slot="filters">
          <el-row :gutter="10">
            <el-col :span="6">
              <div class="block">
                <el-date-picker
                  size="small"
                  class="width-100"
                  v-model="filterDateRange"
                  type="daterange"
                  range-separator=" / "
                  @input="updateFilters"
                  format="dd-MM-yyyy"
                  start-placeholder="Từ ngày"
                  end-placeholder="Đến ngày">
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
        </section>
        <template slot-scope="datas">
          <el-table
            :data="datas.data"
            border
            style="width: 100%">
          >
            <el-table-column
                label="#"
                width="80"
              >
                <template slot-scope="scope">
                  <small v-if="dataPaginations[invoiceReportTable]">{{(scope.$index + 1) + ((dataPaginations[invoiceReportTable].current_page -1) * dataPaginations[invoiceReportTable].per_page)}}</small>
                </template>
              </el-table-column>

            <el-table-column
              label="Đối soát"
              width="200"
            >
              <template slot-scope="scope">
                <p v-if="scope.row.cross_check && scope.row.cross_check.data.id">
                  <el-tooltip placement="top" content="Mã đối soát" class="display-inline">
                    <span class="shipment-code-display click-copy">{{scope.row.cross_check.data.id}}</span>
                  </el-tooltip>
                </p>
                <p v-if="scope.row.cross_check">Ngày: {{ scope.row.cross_check.data.created_at }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="Phiếu chi"
              width=""
            >
              <template slot-scope="scope">
                <p>Tổng phiếu: <span class="pull-right">{{scope.row.total | number}}</span></p>
                <p>Tổng tiền: <span class="pull-right text-red">{{scope.row.total_amount | vnd}}</span></p>
              </template>
            </el-table-column>
            <el-table-column
              label="Phiếu chi đã thanh toán"
              width=""
            >
              <template slot-scope="scope">
                <p>Tổng phiếu: <span class="pull-right">{{scope.row.total_payed | number}}</span></p>
                <p>Tổng tiền: <span class="pull-right text-red">{{scope.row.total_amount_payed | vnd}}</span></p>
              </template>
            </el-table-column>
            <el-table-column
              label="Phiếu chi đã xác nhận"
              width=""
            >
              <template slot-scope="scope">
                <p>Tổng phiếu: <span class="pull-right">{{scope.row.total_confirm | number}}</span></p>
                <p>Tổng tiền: <span class="pull-right text-red">{{scope.row.total_amount_confirm | vnd}}</span></p>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script>
  import ls from 'local-storage'
  import { debounce, keys, forEach } from 'lodash'
  import { formatDate } from 'src/helpers'
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'Invoice',
    data () {
      return {
        invoiceReportTable: 'invoiceReport',
        filterDateRange: '',
        filters: {
          sort: 'created_at:-1',
          start_date: '',
          end_date: '',
          include: 'cross_check'
        },
        sorted: {
          created_at: -1
        },
        sorts: [
          {key: 'created_at', name: 'Ngày tạo'}
        ],
        showData: false
      }
    },
    computed: {
      ...mapGetters('invoice', ['invoice'])
    },
    methods: {
      ...mapActions('invoice', ['setInvoice']),
      updateFilters (data) {
        this.filters.start_date = formatDate(data[0])
        this.filters.end_date = formatDate(data[1])
        this.filter()
      },
      filter: debounce(function () {
        let lsFilter = ls.get('filters', {})
        if (!lsFilter) {
          lsFilter = {}
        }
        lsFilter[this.invoiceReportTable] = this.filters
        ls.set('filters', lsFilter)
        if (ls.get('doFilter')) {
          this.reloadGsTable(this.invoiceReportTable)
        }
      }, 300),
      removeFilter () {
        if (!this.checkDefaultFilter({
          sort: 'created_at:-1',
          start_date: '',
          end_date: '',
          include: 'cross_check'
        }) || this.filters.is_confirm !== 0 || this.filters.is_confirm !== -1) {
          this.reloadGsTable(this.invoiceReportTable)
        }
        this.filterDateRange = ''
        this.filters = {
          sort: 'created_at:-1',
          start_date: '',
          end_date: '',
          include: 'cross_check'
        }
      },
      checkDefaultFilter (filters) {
        let diff = false
        let lkeys = keys(filters)
        forEach(lkeys, key => {
          if (filters[key] !== this.filters[key]) {
            this.diff = true
          }
        })
        return diff
      }
    },
    mounted () {
      this.clickToCopy()
      if (ls.get('filters') && ls.get('filters')[this.invoiceReportTable]) {
        this.filters = ls.get('filters')[this.invoiceReportTable]
        setTimeout(() => {
          ls.set('doFilter', true)
        }, 100)
      }
      setTimeout(() => {
        this.showData = true
      }, 200)
      this.listenReloadGsTable()
      if (Object.keys(this.getSorted(this.invoiceReportTable)).length) {
        this.sorted = this.getSorted(this.invoiceReportTable)
      }
    },
    beforeRouteEnter (to, from, next) {
      if (from.fullPath === '/') {
        ls.remove('filters')
        ls.set('doFilter', true)
      } else {
        if (ls.get('filters') && ls.get('filters')['invoiceReport']) {
          ls.set('doFilter', false)
        } else {
          ls.set('doFilter', true)
        }
      }
      next()
    }
  }
</script>

<style lang="css" scoped>
  .active-status{
    font-weight: bold;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// InvoiceReport.vue?5bb8b26e